export const RANDOM_USER_API_BASE_URL = 'https://randomuser.me/api/1.0/';


// WEBPACK FOOTER //
// ./src/constants/urls.js